export default {
  getHeaderOffset: () => {
    return $(window).innerWidth() >= 1000
      ? 0
      : $('.mHeader-head').innerHeight() * -1;
  }
};



// WEBPACK FOOTER //
// ./scripts/util/layouts.js